import { render, staticRenderFns } from "./HeaderForm.vue?vue&type=template&id=645337c1&scoped=true"
import script from "./HeaderForm.vue?vue&type=script&lang=js"
export * from "./HeaderForm.vue?vue&type=script&lang=js"
import style0 from "./HeaderForm.vue?vue&type=style&index=0&id=645337c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645337c1",
  null
  
)

export default component.exports